<template>
  <td>{{ prettyUser }}</td>
</template>

<script>
export default {
  props: ['username'],
  computed: {
    prettyUser() {
      if (!this.username) return ''

      if (!this.username.includes('@')) return this.username

      const i = this.username.indexOf('@')
      const pretty = this.username.substring(0, i)

      return pretty
    }
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/General/TdUser.vue